import { render, staticRenderFns } from "./TableItensNotaFiscal.vue?vue&type=template&id=5ff98944"
import script from "./TableItensNotaFiscal.vue?vue&type=script&lang=js"
export * from "./TableItensNotaFiscal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports